import { Heartbeat } from '../Heartbeat';
import type { BrightScriptMessenger } from './BrightScriptMessenger';

export class BrightScriptMessengerHeartbeat extends Heartbeat {
    constructor(messenger: BrightScriptMessenger) {
        super({
            enable: async () => {
                await messenger.postMessage('ENABLE_WATCHDOG');
            },
            ping: async () => {
                await messenger.postMessage('PING');
            },
        });
    }
}
